import {
  SET_INVOICE_DATA,
  SET_INVOICE_COUNT,
  SET_INVOICE_SUMMARY
} from "../../actions/types/types";

const initState = {
  invoices: [],
  invoiceCount: 0,
  invoiceSummary: []
};

const InvoiceReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_INVOICE_COUNT:
      return {
        ...state,
        invoiceCount: action.payload.data
      };

    case SET_INVOICE_DATA:
      return {
        ...state,
        invoices: action.payload.data
      };
    case SET_INVOICE_SUMMARY:
      return {
        ...state,
        invoiceSummary: action.payload.data
      };

    default:
      return { ...state };
  }
};

export default InvoiceReducer;
